<template>
  <div class="flex flex-col min-h-screen items-center">
    <div class="flex justify-between items-center w-full max-w-[1280px]">
      <div class="flex">
        <PopupUserMenu
          :user="user"
          :active-item="'accountInfo'"
        />
        <LogoIcon />
      </div>
      <DropdownMenu />
    </div>
    <div class="flex flex-grow max-w-[1280px] mt-[60px] mx-auto w-full">
      <UserMenu
        :user="user"
        :active-item="'accountInfo'"
      />
      <AccountInfo />
    </div>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/auth';
import LogoIcon from '@/components/LogoIcon.vue';
import DropdownMenu from "@/components/DropdownMenu.vue";
import UserMenu from "@/components/UserMenu.vue";
import AccountInfo from "@/components/AccountInfo.vue";
import PopupUserMenu from "@/components/PopupUserMenu.vue";

export default {
    name: 'UserInfoPage',
    components: {
        PopupUserMenu,
        LogoIcon,
        DropdownMenu,
        UserMenu,
        AccountInfo,
    },
    async created() {
        const authStore = useAuthStore();
        await authStore.fetchCurrentUser(); // Refresh user data to get latest passwordless_status
    },
    computed: {
        user() {
            const authStore = useAuthStore();
            return authStore.current_user || {
                first_name: 'N/A',
                last_name: 'N/A',
                email: 'no-email@example.com',
                country: 'TW',
                contactPerson: 'None'
            };
        },
    },
}
</script>